import React, { useState } from 'react';
import { Form, InputNumber, Popover } from 'antd';
import { useLocation } from 'react-router-dom';
import { ReactComponent as AddPassenger } from '../../../../resources/images/svg/addPassenger.svg';
import './CustomerPassengerInput.scss';
import AddPassengersInputContent from './AddPassengersInputContent';
import useTranslation from '../../../hooks/translation/useTranslation';
import useWindowDimensions from '../../../hooks/useWindowDimensions';

function CustomerPassengersInput({ className, form, errorMessage }) {
  const { width } = useWindowDimensions();

  const location = useLocation();
  const isHomePage = location.pathname === '/ka' || location.pathname === '/en' || location.pathname === '/am';

  const placement = isHomePage && width < 1024
    ? 'top'
    : 'bottom';

  const [open, setOpen] = useState(
    false,
  );
  const standard = Form.useWatch('standard_passengers', form);
  const child = Form.useWatch('child_passengers', form);
  const disabled = Form.useWatch('disabled_passengers', form);
  const { trans } = useTranslation();

  return (
    <Popover
      overlayStyle={{ zIndex: 5 }}
      content={(
        <AddPassengersInputContent
          form={form}
          closeBtn
          setOpen={setOpen}
          disabled={disabled}
          standard={standard}
          child={child}
        />
      )}
      open={open}
      placement={placement}
    >
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`flex gap-4 flex-[2] items-center justify-center h-[60px] bg-gray-light-gr rounded-lg cursor-pointer duration-300 ease-out border-[1px] border-solid ${className} ${
          errorMessage ? 'border-red-gr' : 'border-transparent'
        } hover:border-black `}
      >
        <AddPassenger />
        <p className="text-black m-0">
          {standard + disabled + child > 0
            ? `${standard + disabled + child} ${trans('passenger')}`
            : trans('add_passengers')}
        </p>
        <div className="hidden">
          <Form.Item name="standard_passengers" initialValue={standard}>
            <InputNumber />
          </Form.Item>
          <Form.Item name="child_passengers" initialValue={child}>
            <InputNumber />
          </Form.Item>
          <Form.Item name="disabled_passengers" initialValue={disabled}>
            <InputNumber />
          </Form.Item>
        </div>
      </button>
    </Popover>
  );
}

export default CustomerPassengersInput;
